import { withNavigation } from "../../Common/withNavigation";
import { connect } from "react-redux";
import Home from "./Home";
import { getCustomerCategoryTree } from "../../utils/catalogMenuView";
import { getNavigationCategories } from "../../utils/clinicalPlanners";
import {
  insertCartRequest,
  getHomeproductdataRequest,
  getCartRequest,
  getproductbycategoryidRequest,
  addwishlistrequest,
  removewishlistrequest,
  getcategorywithsubcategoryRequest,
  getproductwithbrandRequest,
  getsubcategorywithproductRequest,
  getBannersRequest,
} from "./Home-slice";
import {
  getBrandRequest,
  getcategoryRequest,
  getProductRequest,
} from "../Product/Product-slice";

const mapStateToProps = (state) => {
  // console.log("getcategorywithsubcategorydata---->", state.Home.getcategorywithsubcategorydata?.data);
  return {
    categorydata: getNavigationCategories(state.Product.categorydata?.data),
    productdata: state.Product.productdata?.data,
    addcartdata: state.Home.Cartdata,
    Homeproductdata: state.Home.getHomeproductdata?.data,
    addwishlistdata: state.Home.addwishlistdata,
    removewishlistdata: state.Home.removewishlistdata,
    branddata: state.Product.branddata?.data,
    categorywithsubcategorydata:
      getCustomerCategoryTree(state.Home.getcategorywithsubcategorydata?.data),
    topBanners: state.Home.topBanners,
    smallBanners: state.Home.smallBanners,
    smallBanner: state.Home.smallBanner,
    bottomBanners: state.Home.bottomBanners,
    loading: state.Home.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    insertCartRequest: (data) => dispatch(insertCartRequest(data)),
    getcategoryRequest: (data) => dispatch(getcategoryRequest(data)),
    getProductRequest: (data) => dispatch(getProductRequest(data)),
    getHomeproductdataRequest: () => dispatch(getHomeproductdataRequest()),
    getCartRequest: () => dispatch(getCartRequest()),
    getproductbycategoryidRequest: (data) =>
      dispatch(getproductbycategoryidRequest(data)),
    addwishlistrequest: (data) => dispatch(addwishlistrequest(data)),
    removewishlistrequest: (data) => dispatch(removewishlistrequest(data)),
    getBrandRequest: () => dispatch(getBrandRequest()),
    getcategorywithsubcategoryRequest: () =>
      dispatch(getcategorywithsubcategoryRequest()),
    getproductwithbrandRequest: (data) =>
      dispatch(getproductwithbrandRequest(data)),
    getsubcategorywithproductRequest: (data) =>
      dispatch(getsubcategorywithproductRequest(data)),
    getBannersRequest: () => dispatch(getBannersRequest()),
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(Home)
);
